"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumCompanyProfileFeatures = exports.Picture = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
const features = [
    {
        key: 1,
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.analytics" }),
        image: 'increasing-line-bar-chart-business',
        description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.analytics_description" }),
    },
    {
        key: 2,
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.photos_and_videos_offer" }),
        image: 'folder-image-1-image',
        description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.photos_and_videos_offer_description" }),
    },
    {
        key: 3,
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.photos_and_videos_public_profile" }),
        image: 'ux-ui-example-design',
        description: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.photos_and_videos_public_profile_description" })),
    },
    {
        key: 4,
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.highlighting_company_profile" }),
        image: 'avatar-neutral-add-users',
        description: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.highlighting_company_profile_description" })),
    },
    {
        key: 5,
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.main_page_company_logo" }),
        image: 'vip-app',
        description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.features.main_page_company_logo_description" }),
    },
];
const PremiumCompanyProfileFeatures = () => {
    return ((0, jsx_runtime_1.jsx)(StyledFeatures, { children: features.map(({ key, name, image, description }) => ((0, jsx_runtime_1.jsxs)(Box, { children: [(0, jsx_runtime_1.jsx)(exports.Picture, { children: (0, jsx_runtime_1.jsx)("img", { src: `/media/illustrations/streamline-icon-${image}.svg`, alt: "" }) }), (0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(FeatureTitle, { children: name }), (0, jsx_runtime_1.jsx)("div", { children: description })] })] }, key))) }));
};
exports.PremiumCompanyProfileFeatures = PremiumCompanyProfileFeatures;
exports.Picture = styled_components_1.default.div `
	width: 150px;
	height: 150px;
	overflow: hidden;
	align-self: center;
	& img {
		display: block;
		max-width: 100%;
	}
`;
const Box = styled_components_1.default.div `
	width: 100%;
	padding: 0 2em 3em;
	display: flex;
	position: relative;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('sm')} {
		width: 50%;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		width: 33%;
	}
`;
const StyledFeatures = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: initial;
	}
`;
const Content = styled_components_1.default.div `
	align-self: center;
	flex: 1;
	text-align: center;
`;
const FeatureTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.brand2};
	font-size: 1.2em;
	font-weight: 700;
	margin: 0 0 0.5em;
`;
